<template>
  <div>
    <app-loading v-if="isLoading"></app-loading>
    <main class="card-list main-top-space" v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getRankingBooks" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <app-book v-for="(book, index) in books" :isCreditAvailabel="isCreditAvailabel" :rankingNumber="index + 1" :bookInfo="book" :key="book.id_book + '-ranking-page-' + index"></app-book>
      </div>
    </main>
  </div>
</template>

<script>
  import TopInformation from '../common/TopInformation.vue';
  import Book from '../books/Book.vue';
  import { topInformation } from '../../constants';
  import Loading from '../common/Loading.vue';
  import $ from 'jquery';

  export default {
    title: 'ストア | abceed',
    headerTitle: 'ランキング',
    description: '「金フレ」「でる1000」「至高の模試」など、TOEIC有名教材がスマホアプリで学習できる！abceed上で最も人気のあるTOEIC教材はこちら',
    keywords: 'toeic,abceed,globee,ランキング',
    headerType: 'default',
    components: {
      appTopInformation: TopInformation,
      appBook: Book,
      appLoading: Loading
    },
    data() {
      return {
        topInformation,
        responseError: false,
        isCreditAvailabel: false,
        showPremiumBanner: false,
        showUnlimitedBanner: false,
      }
    },
    created() {
      this.getRankingBooks();
    },
    methods: {
      getRankingBooks() {
        this.$store.dispatch("changeLoadingCondition", true);
        let token = "";
        let type = "";
        if (this.$route.query.token) {
          token = this.$route.query.token;
        }
        if (this.$route.query.type) {
          type = this.$route.query.type;
        }

        this.$store.dispatch("getBookRanking", {token:token, type:type})
          .then(data => {
            if (data === 'error') {
              this.responseError = true;
              $('#app').css('height', 'auto');
              return;
            } else {
              if (data.book_list.length > 0) this.responseError = false;
              this.showPremiumBanner = data.show_premium_banner;
              this.showUnlimitedBanner = data.show_unlimited_banner;
              $('#app').css('height', 'auto');
            }

            const isPcAccess = this.checkPC();
            //クレジットカードが使用可能か調べる
            if (this.isLogin && isPcAccess) {
              this.$store.dispatch('getUserSettings', {token:""})
                .then(data => {
                  this.responseError = data === 'error';
                  if (data.user.sbps_payment_type && data.user.sbps_payment_type === 'credit') {
                    this.isCreditAvailabel = true;
                  }
                  this.$store.dispatch("changeLoadingCondition", false);
                })
                .catch(() => {
                  this.responseError = true;
                  this.$store.dispatch("changeLoadingCondition", false);
                });
            } else {
              this.$store.dispatch("changeLoadingCondition", false);
            }
            if (this.$route.query.result === "ok") {
              this.$store.dispatch("showLightBox", "subscriptionResult");
            }
            if (this.$route.query.result === "unlimitedok") {
              this.$store.dispatch("showLightBox", "unlimitedResult");
            }
            if (this.$route.query.result === "yadokariok") {
              this.$store.dispatch("showLightBox", "yadokariResult");
            }
            //ログイン成功の場合はログイン処理を行う
            if (data.has_logined) {
              if (data.login_info) {
                this.$store.dispatch("setLogin", data.login_info);
              }
            }
            this.$store.dispatch("setSubscriptions", data.subscriptions);
          }).catch(() => {
            this.responseError = true;
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      checkPC() {
        const ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
            return false;
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            return false;
        } else {
            return true;
        }
      }
    },
    computed: {
      books() {
        return this.$store.getters.bookRanking;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      },
      isLogin() {
        return this.$store.getters.isLogin;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/bookList/Ranking.vue